import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/account-configs`;

export const accountConfigs = {
  update: async ({ id, data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  floorDropTypes: {
    getAll: async ({ id, signal } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${id}/floor-drop-types`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        signal,
      });
      return apiRequest(options);
    },
    update: async ({ id, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${id}/floor-drop-types`,
        method: "put",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
  materials: {
    getAll: async ({ id, filters, sort, top, signal } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${id}/materials`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        signal,
        filters,
        sort,
        top,
      });
      return apiRequest(options);
    },
    update: async ({ id, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${id}/materials`,
        method: "put",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
